import languages from "../i18n";
import menuItems from "./menuItems";
const hotelsCRMURI = "https://hotelscrm.app/public/";

export { languages, menuItems, hotelsCRMURI };
